import "../../assents/styles/components/Cards.scss";
import riwi from "../../assents/riwi.webp";
import { useState } from "react";

function PortapholioCard() {
  const [activeProject, setActiveProject] = useState(null);

  const projects = [
    {title: "GAME JS",
      link: "https://game-js-riwi.web.app"

    },

    {
      title: "Login",
      link: "https://denisv2112.github.io/login/",
    },
    {
      title: "Web Musical",
      link: "https://denisv2112.github.io/WebMusical/",
    },
    {
      title: "Cultural Carnival",
      link: "https://denisv2112.github.io/culturalCarnival/",
    },
    {
      title: "Login",
      link: "https://denisv2112.github.io/login/",
    },
    
  ];

  return (
    <div className="portaphlio">
      <div className="text_container">
        <p className="card--title-start">Hi,</p>
        <p className="card--title-end">This is a demo.</p>
        <span className="hover-text-start" aria-hidden="true">ⴰⵣⵉⵍ,</span>

        <div className="clubs-span">
          <span className="clubs-span-1">♣</span>
          <span className="clubs-span-2">♣</span>
          <span className="clubs-span-3">♣</span>
        </div>
      </div>

      <div className="card__section">
        <div className="riwi">
          <h1 className="riwi__projects--title">Riwi</h1>
          <img className="riwi__projects--img" src={riwi} />
        </div>

        <div className="card__container">
          {projects.map((project, index) => (
            <div
              key={index}
              className="card__container--map__container"
              onClick={() => setActiveProject(project)}
              style={{ cursor: "pointer" }}
            >
              <iframe src={project.link} title={`iframe-${index}`} />
              <div className="p-4">
                <h3>{project.title}</h3>
                <button className="card--button">Click here!</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <span className="hover-text-end" aria-hidden="true">ⵡⴰⴷⴰⵙⴽⴰⵏ</span>

      {activeProject && (
        <div className="modal-overlay" onClick={() => setActiveProject(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setActiveProject(null)}>x</button>
            <iframe src={activeProject.link} title="iframe-modal" />
          </div>
        </div>
      )}
    </div>
  );
}

export default PortapholioCard;